import React, { useMemo } from 'react';
import { useStyles } from './styles';
import { CircularProgress, Divider } from '@material-ui/core';
import { QuestionnaireContainer } from 'pages/formsCreate/Preview/QuestionareContainer';
import { FormAbout } from 'pages/formsCreate/Preview/FormAbout';
import { AnswerFormProvider } from './context';
import { IRouterProps } from 'pages/orderHistory';
import { useAnswerManager } from 'pages/forms/hooks/useAnswerManager';
import { AnswerContext } from 'pages/forms/context';
import { Footer } from './Footer';
import { useAnswerForm } from './hooks/useAnswerForm';

type Params = {
  params?: Record<string, string | undefined>;
};

export const FormAnswer = ({ router, params }: IRouterProps & Params) => {
  const { container, loadingCircular } = useStyles();

  const answersConfig = useAnswerManager();
  const config = useAnswerForm({ params, answersConfig, router });

  const isLoading = useMemo(() => {
    return config.supplierLoading || config.isLoadingFormData || config.isSubmitDataLoading;
  }, [config]);

  if (isLoading) return <CircularProgress className={loadingCircular} />;

  if (!config.formData) return null;
  return (
    <AnswerContext.Provider value={answersConfig}>
      <AnswerFormProvider value={config}>
        <config.Snackbar />
        <main className={container}>
          <FormAbout data={config.formData} />
          <Divider />
          <QuestionnaireContainer data={config.formData?.questions || []} />
          <Footer router={router} />
        </main>
      </AnswerFormProvider>
    </AnswerContext.Provider>
  );
};
